<template>
    <div>
        <ComponentHeader />
        <main>
            <HeroComponent title="How we work" pageClass="worklineAbout" img="images_work_line/work_main_bacground.png"
                position="30" />
            <section class="WorkLineSection">
                <div class="WorkLineWrapper ">
                    <div class="WorkLineBody ">
                        <h2>About PixYz Agency</h2>
                        <ul>
                            <li>
                                <img src="../assets/images/img_idea.png" alt="">
                                <div>
                                    <h4>First discussion</h4>
                                    <p>The first step is to give an overview of the problem we want to
                                        solve and / or our needs. If the needs are not properly
                                        understood, this will cause the creation of a web application
                                        that is designed for these purposes to fail.</p>
                                </div>
                            </li>
                            <li>
                                <img src="../assets/images/img_users.png" alt="">
                                <div>
                                    <h4>Requirements analysis</h4>
                                    <p>The goal was to define the goals for implementing the web
                                        application. Tasks can be complex, and business logic is often
                                        quite complex. At this stage, it is important that these complex
                                        tasks can be broken down into more manageable tasks and,
                                        therefore, they are easier to implement, verify, and test.</p>
                                </div>
                            </li>
                            <li>
                                <img src="../assets/images/img_group.png" alt="">
                                <div>
                                    <h4>Timeline and Cost Estimation</h4>
                                    <p>Experience is a good ally when it comes to making the right
                                        assessment. If a similar task was completed earlier, it becomes
                                        easier to give an accurate estimate, and time tracking becomes
                                        our recommendation. From the previous step, we can collect all
                                        the pieces that we are going to collect from end to end. For <br>
                                        each task, we analyze its complexity and make a classification.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <img src="../assets/images/images_work_line/work_list_office.png" alt="">
                                <div>
                                    <h4>The design, Conception, and planing</h4>
                                    <p>The evaluation gives us an idea of the time required to
                                        complete the entire project. At this stage, our goal is to answer
                                        the following questions: who does what and when? What is the
                                        best technical approach?</p>
                                </div>
                            </li>
                            <li>
                                <img src="../assets/images/images_work_line/work_list_plan.png" alt="">
                                <div>
                                    <h4>The development</h4>
                                    <p>This is the most famous step. Once the product requirements
                                        document is installed, the development phase can begin. The
                                        goal of this stage is to create an application that meets the
                                        needs identified in previous stages, and since needs tend to
                                        evolve and new implomentation ideas may arise during the implementation stage,
                                        it is usually recommended to use a methodology that provides flexibility and
                                        proactivity.</p>
                                </div>
                            </li>
                            <li>
                                <img src="../assets/images/images_work_line/work_list_testing.png" alt="">
                                <div>
                                    <h4>The testing phase</h4>
                                    <p>This stage is also called the user acceptance test. At this stage,
                                        the test group of users checks the feature set and reports
                                        errors, if any. if there are any changes, you can discuss them
                                        with the project Manager, who will advise you on the best way
                                        to account for input data and feedback.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <img src="../assets/images/images_work_line/work_line_fast.png" alt="">
                                <div>
                                    <h4>The deployment and post-production
                                        phase</h4>
                                    <p>After each feature in a given release has been checked and all
                                        error messages have been fixed, the deployment stage may
                                        begin, this may be the first launch or deployment of a new
                                        release, this is the moment when the web application will work
                                        in its real environment. <br>
                                        Some behaviors only appear in the production environment,
                                        such as performance load balancer.it is important to set aside
                                        time for support and maintenance to fix any errors or
                                        performance issues found after the application is launched.

                                    </p>
                                    <p>New ideas for expansion may appear as soon as the app is up
                                        and running, the post-production phase is the best time to
                                        discuss other needs.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </main>
        <FooterCompinent />
    </div>
</template>

<script>
    import ComponentHeader from "@/components/Header.vue";
    import FooterCompinent from "@/components/Footer.vue";
    import HeroComponent from "@/components/HeroComonent.vue"
    export default {
        name: "AboutView",
        components: {
            ComponentHeader,
            FooterCompinent,
            HeroComponent
        },
    }
</script>

<style scoped lang="scss">
    .WorkLineSection {
        .WorkLineWrapper {
            width: 1200px;
            margin: 0 auto;
            .WorkLineBody {
                h2 {
                    font-size: 40px;
                    color: #217a73;
                    text-align: center;
                    font-weight: 600;
                    margin-top: 100px;
                }

                ul {
                    margin-top: 73px;

                    li {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        position: relative;
                        margin-bottom: 300px;

                        img {
                            margin-left: 60px;
                        }

                        div {
                            margin: auto 0;
                            margin-left: 126px;

                            h4 {
                                font-size: 28px;
                                color: #217a73;
                                margin-top: 0px;
                                font-weight: 600;
                                margin-bottom: 0px;
                                margin-top: 20px;
                                margin-bottom: 30px;
                            }

                            p {
                                font-size: 24px;
                                color: #8a8a8a;
                                width: 670px;
                                line-height: 40px;
                            }
                        }
                    }

                    li:nth-child(2) {
                        position: relative;
                        margin-bottom: 300px;

                        img {
                            margin-right: -45px !important;
                            margin-top: -20px;
                        }

                        div {
                            margin: auto 0;
                            margin-left: -80px !important;

                            h4 {
                                font-size: 29px;
                                color: #217a73;
                                margin-top: 0px;
                                font-weight: 600;
                                margin-bottom: 0px;
                                margin-top: -40px;
                                margin-bottom: 30px;
                            }

                            p {
                                font-size: 24px;
                                color: #8a8a8a;
                                width: 690px;
                                line-height: 40px;
                                margin-left: 3px;
                            }
                        }
                    }

                    li:nth-child(3) {
                        display: flex;
                        position: relative;
                        margin-bottom: 300px;

                        img {
                            margin-left: 60px;
                            width: 333px;
                            margin-top: -36px;
                        }

                        div {
                            margin: auto 0;
                            margin-left: 126px;
                            margin-right: -105px;

                            h4 {
                                font-size: 29px;
                                color: #217a73;
                                margin-top: 0px;
                                font-weight: 600;
                                margin-bottom: 0px;
                                margin-top: -22px;
                                margin-bottom: 30px;
                            }

                            p {
                                font-size: 24px;
                                color: #8a8a8a;
                                width: 700px;
                                line-height: 40px;
                            }
                        }
                    }

                    li:nth-child(4) {
                        position: relative;
                        margin-bottom: 300px;

                        img {
                            margin-right: -38px !important;
                            margin-top: 18px;
                        }

                        div {
                            margin: auto 0;
                            margin-left: -80px !important;

                            h4 {
                                font-size: 29px;
                                color: #217a73;
                                margin-top: 0px;
                                font-weight: 600;
                                margin-bottom: 0px;
                                margin-top: 65px;
                                margin-bottom: 28px;
                            }

                            p {
                                font-size: 24px;
                                color: #8a8a8a;
                                width: 680px;
                                line-height: 40px;
                                margin-left: 3px;
                            }
                        }
                    }

                    li:nth-child(5) {
                        position: relative;
                        margin-bottom: 300px;

                        img {
                            margin-right: 10px !important;
                            margin-left: -36px;
                            margin-top: -42.5px;
                        }

                        div {
                            margin: auto 0;
                            margin-left: 173.5px !important;

                            h4 {
                                font-size: 29px;
                                color: #217a73;
                                margin-top: 0px;
                                font-weight: 600;
                                margin-bottom: 0px;
                                margin-top: -35.5px;
                                margin-bottom: 28px;
                            }

                            p {
                                font-size: 24px;
                                color: #8a8a8a;
                                width: 680px;
                                line-height: 40px;
                                margin-left: 3px;
                            }
                        }
                    }

                    li:nth-child(6) {
                        position: relative;
                        margin-bottom: 300px;

                        img {
                            margin-right: -15px !important;
                            margin-left: 30px;
                            margin-top: -59.5px;
                        }

                        div {
                            margin: auto 0;
                            margin-left: -81px !important;

                            h4 {
                                font-size: 29px;
                                color: #217a73;
                                margin-top: 0px;
                                font-weight: 600;
                                margin-bottom: 0px;
                                margin-top: -60px;
                                margin-bottom: 28px;
                            }

                            p {
                                font-size: 24px;
                                color: #8a8a8a;
                                width: 690px;
                                line-height: 40px;
                                margin-left: 3px;
                            }
                        }
                    }

                    li:nth-child(7) {
                        position: relative;
                        overflow-y: hidden;
                        overflow-x: hidden;
                        width: 1300px;
                        height: 640px;
                        margin-top: -30px;
                        margin-bottom: 0 !important;

                        img {
                            margin-right: -15px !important;
                            margin-left: 30px;
                            margin-top: 79px;
                            width: 330px;
                            height: 1150px;
                        }

                        div {
                            margin: auto 0;
                            margin-left: -10px !important;

                            h4 {
                                font-size: 29.5px;
                                color: #217a73;
                                margin-top: 0px;
                                font-weight: 600;
                                margin-bottom: 0px;
                                margin-top: -0px;
                                line-height: 40px;
                                margin-bottom: 24px;
                                margin-left: -0px;
                                width: 600px;
                            }

                            p {
                                font-size: 24px;
                                color: #8a8a8a;
                                width: 690px;
                                line-height: 40px;
                                margin-left: 0px;
                                margin-right: 5px;
                                margin-bottom: 40px;
                            }
                        }
                    }

                    li:nth-child(2n) {
                        flex-direction: row-reverse;
                    }

                    li:nth-child(1):after {
                        content: "";
                        position: absolute;
                        background-image: url("../assets/images/Group 1582.png");
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 1200px;
                        height: 400px;
                        top: 80%;
                        left: 0.5%;
                    }

                    li:nth-child(2):after {
                        content: "";
                        position: absolute;
                        background-image: url("../assets/images/Group 1583.png");
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 600px;
                        height: 300px;
                        top: 100%;
                        right: 3.3%;
                    }

                    li:nth-child(3):after {
                        content: "";
                        position: absolute;
                        background-image: url("../assets/images/images_work_line/Group 1586.png");
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 1400px;
                        height: 500px;
                        top: 85.7%;
                        left: -5.4%;
                    }

                    li:nth-child(4):after {
                        content: "";
                        position: absolute;
                        background-image: url("../assets/images/images_work_line/Group 1587.png");
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 998px;
                        height: 348px;
                        top: 85.5%;
                        right: -5px;
                    }

                    li:nth-child(5):after {
                        content: "";
                        position: absolute;
                        background-image: url("../assets/images/images_work_line/Group 1589.png");
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 1127px;
                        height: 500px;
                        top: 89%;
                        right: 0.5%;
                    }

                    li:nth-child(6):after {
                        content: "";
                        position: absolute;
                        background-image: url("../assets/images/images_work_line/Group 1588.png");
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 1100px;
                        height: 450px;
                        top: 74.5%;
                        left: 30.7%;
                    }


                }
            }
        }
    }
    footer {
        margin-top: 78px !important;
    }
    @media only screen and (max-width: 1900px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 1200px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 40px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-left: 60px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 126px;

                                h4 {
                                    font-size: 28px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 670px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: -45px !important;
                                margin-top: -20px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -80px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -40px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 690px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-left: 60px;
                                width: 333px;
                                margin-top: -36px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 126px;
                                margin-right: -105px;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -22px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 700px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: -38px !important;
                                margin-top: 18px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -80px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 680px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: 10px !important;
                                margin-left: -36px;
                                margin-top: -42.5px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 173.5px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -35.5px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 680px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: -15px !important;
                                margin-left: 30px;
                                margin-top: -59.5px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -81px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -60px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 690px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 1300px;
                            height: 640px;
                            margin-top: -30px;
                            margin-bottom: 0 !important;

                            img {
                                margin-right: -15px !important;
                                margin-left: 30px;
                                margin-top: 79px;
                                width: 330px;
                                height: 1150px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -10px !important;

                                h4 {
                                    font-size: 29.5px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 600px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 690px;
                                    line-height: 40px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1200px;
                            height: 400px;
                            top: 80%;
                            left: 0.5%;
                        }

                        li:nth-child(2):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 600px;
                            height: 300px;
                            top: 100%;
                            right: 3.3%;
                        }

                        li:nth-child(3):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1400px;
                            height: 500px;
                            top: 85.7%;
                            left: -5.4%;
                        }

                        li:nth-child(4):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 998px;
                            height: 348px;
                            top: 85.5%;
                            right: -5px;
                        }

                        li:nth-child(5):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1127px;
                            height: 500px;
                            top: 89%;
                            right: 0.5%;
                        }

                        li:nth-child(6):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 450px;
                            top: 74.5%;
                            left: 30.7%;
                        }


                    }
                }
            }
        }
    }

    @media only screen and (max-width: 1450px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 1100px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 40px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-left: 0px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 126px;

                                h4 {
                                    font-size: 28px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    max-width: 670px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: -55px !important;
                                margin-top: -20px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -80px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -40px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    max-width: 690px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-left: 60px;
                                width: 333px;
                                margin-top: -36px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 126px;
                                margin-right: -105px;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -22px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 700px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: -38px !important;
                                margin-top: 18px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -80px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 680px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: 10px !important;
                                margin-left: -36px;
                                margin-top: -42.5px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 100.5px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -35.5px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: -15px !important;
                                margin-left: 30px;
                                margin-top: -50.5px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -81px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -50px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 1200px;
                            height: 640px;
                            margin-top: -30px;
                            margin-bottom: 0 !important;

                            img {
                                margin-right: -15px !important;
                                margin-left: 30px;
                                margin-top: 79px;
                                width: 330px;
                                height: 1150px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -10px !important;

                                h4 {
                                    font-size: 29.5px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 600px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    max-width: 690px;
                                    line-height: 40px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1100px;
                            height: 400px;
                            top: 80%;
                            left: 0.5%;
                        }

                        li:nth-child(2):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 300px;
                            top: 100%;
                            right: 3.3%;
                        }

                        li:nth-child(3):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1200px;
                            height: 550px;
                            top: 90%;
                            left: -5.4%;
                        }

                        li:nth-child(4):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 998px;
                            height: 348px;
                            top: 85.5%;
                            right: -5px;
                        }

                        li:nth-child(5):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1127px;
                            height: 500px;
                            top: 89%;
                            right: 0.5%;
                        }

                        li:nth-child(6):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 450px;
                            top: 74.5%;
                            left: 20.7%;
                        }


                    }
                }
            }
        }
    }

    @media only screen and (max-width: 1310px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 1100px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 40px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-left: 0px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px;

                                h4 {
                                    font-size: 28px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: -5px !important;
                                margin-top: -20px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -0px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -40px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    max-width: 620px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-left: 20px;
                                width: 333px;
                                margin-top: -36px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 126px;
                                margin-right: 0px;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -22px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 700px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: -38px !important;
                                margin-top: 18px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    width: 680px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: 10px !important;
                                margin-left: -36px;
                                margin-top: -42.5px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 100.5px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -35.5px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 300px;

                            img {
                                margin-right: -20px !important;
                                margin-left: 0px;
                                margin-top: -50.5px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -11px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -50px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 24px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 100%;
                            height: 640px;
                            margin-top: -30px;
                            margin-bottom: 0 !important;

                            img {
                                margin-right: -15px !important;
                                margin-left: 30px;
                                margin-top: 79px;
                                width: 330px;
                                height: 1150px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: -10px !important;

                                h4 {
                                    font-size: 29px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 600px;
                                }

                                p {
                                    font-size: 22px;
                                    color: #8a8a8a;
                                    max-width: 690px;
                                    line-height: 35px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1000px;
                            height: 400px;
                            top: 80%;
                            left: 2.5%;
                        }

                        li:nth-child(2):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 450px;
                            height: 250px;
                            top: 109%;
                            right: 5%;
                        }

                        li:nth-child(3):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1000px;
                            height: 500px;
                            top: 90%;
                            left: 6%;
                        }

                        li:nth-child(4):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 998px;
                            height: 348px;
                            top: 85.5%;
                            right: -5px;
                        }

                        li:nth-child(5):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1000px;
                            height: 500px;
                            top: 92%;
                            right: 0.5%;
                        }

                        li:nth-child(6):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 450px;
                            top: 80.5%;
                            left: 15%;
                        }


                    }
                }
            }
        }
    }

    @media only screen and (max-width: 1200px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 1000px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 40px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-around;
                            position: relative;
                            margin-bottom: 250px;

                            img {
                                margin-left: 0px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 250px;

                            img {
                                margin-right: 0px !important;
                                margin-top: 0px;
                            }

                            div {
                                margin: auto 0;
                                margin-right: 10px !important;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -40px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    max-width: 620px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-left: 20px;
                                width: 333px;
                                margin-top: 0px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 50px;
                                margin-right: 0px;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    width: 700px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 250px;

                            img {
                                margin-right: -0px !important;
                                margin-top: 0px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    max-width: 500px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: 10px !important;
                                margin-left: 0px;
                                margin-top: 0px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px !important;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -35.5px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: 0px !important;
                                margin-left: 0px;
                                margin-top: 0.5px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -20px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 100%;
                            height: 640px;
                            margin-top: 0px;
                            margin-bottom: 0 !important;

                            img {
                                margin-right: -0px !important;
                                margin-left: 40px;
                                margin-top: 79px;
                                width: 330px;
                                height: 1150px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 600px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 35px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 1000px;
                            height: 400px;
                            top: 80%;
                            left: 2.5%;
                        }

                        li:nth-child(2):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 450px;
                            height: 250px;
                            top: 109%;
                            right: 5%;
                        }

                        li:nth-child(3):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 900px;
                            height: 500px;
                            top: 95%;
                            left: 6%;
                        }

                        li:nth-child(4):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 650px;
                            height: 250px;
                            top: 105%;
                            right: 140px;
                        }

                        li:nth-child(5):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 900px;
                            height: 500px;
                            top: 92%;
                            right: 0.5%;
                        }

                        li:nth-child(6):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 450px;
                            height: 400px;
                            top: 80.5%;
                            left: 18%;
                        }


                    }
                }
            }
        }
    }

    @media only screen and (max-width: 1110px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 1000px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 35px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-around;
                            position: relative;
                            margin-bottom: 250px;

                            img {
                                margin-left: 0px;
                                width: 300px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    max-width: 550px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 250px;

                            img {
                                margin-right: 0px !important;
                                margin-top: 0px;
                                height: 220px;
                            }

                            div {
                                margin: auto 0;
                                margin-right: 10px !important;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -40px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    max-width: 550px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-left: 20px;
                                width: 250px;
                                height: 300px;
                                margin-top: 0px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 50px;
                                margin-right: 0px;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    width: 700px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 250px;

                            img {
                                margin-right: -0px !important;
                                margin-top: 0px;
                                width: 300px;
                                height: 250px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    max-width: 500px;
                                    line-height: 40px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: 10px !important;
                                margin-left: 0px;
                                margin-top: 0px;
                                width: 300px;
                                height: 250px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px !important;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -20.5px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: 0px !important;
                                margin-left: 0px;
                                margin-top: 0.5px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -20px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 20px;
                                    color: #8a8a8a;
                                    max-width: 500px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 100%;
                            height: 640px;
                            margin-top: 0px;
                            margin-bottom: 0 !important;

                            img {
                                margin-right: -0px !important;
                                margin-left: 40px;
                                margin-top: 79px;
                                width: 300px;
                                height: 900px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 24px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 600px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 550px;
                                    line-height: 35px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 850px;
                            height: 400px;
                            top: 80%;
                            left: 9%;
                        }

                        li:nth-child(2):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 400px;
                            height: 250px;
                            top: 109%;
                            right: 13%;
                        }

                        li:nth-child(3):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 95%;
                            left: 10%;
                        }

                        li:nth-child(4):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 250px;
                            top: 120%;
                            right: 240px;
                        }

                        li:nth-child(5):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 78%;
                            right: 8%;
                        }

                        li:nth-child(6):after {
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 350px;
                            height: 350px;
                            top: 95%;
                            left: 18%;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 1010px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 900px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 35px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-around;
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-left: 0px;
                                width: 250px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 550px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: 0px !important;
                                margin-top: 0px;
                                height: 200px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-right: 10px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -40px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 500px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 150px;

                            img {
                                margin-left: 20px;
                                width: 250px;
                                height: 250px;
                                margin-top: 0px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px;
                                margin-right: 0px;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    margin-bottom: 20px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    width: 700px;
                                    line-height: 35px;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: -0px !important;
                                margin-top: 0px;
                                width: 300px;
                                height: 250px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 500px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: 10px !important;
                                margin-left: 0px;
                                margin-top: 0px;
                                width: 300px;
                                height: 250px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -20.5px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 600px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 150px;

                            img {
                                margin-right: 0px !important;
                                margin-left: 0px;
                                margin-top: 0.5px;
                                width: 300px;
                                height: 250px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -20px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 500px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 100%;
                            height: 640px;
                            margin-top: 0px;
                            margin-bottom: 0 !important;

                            img {
                                margin-right: -0px !important;
                                margin-left: 40px;
                                margin-top: 79px;
                                width: 300px;
                                height: 900px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 600px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 550px;
                                    line-height: 35px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 850px;
                            height: 400px;
                            top: 80%;
                            left: 9%;
                        }

                        li:nth-child(2):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 400px;
                            height: 250px;
                            top: 109%;
                            right: 13%;
                        }

                        li:nth-child(3):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 95%;
                            left: 10%;
                        }

                        li:nth-child(4):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 250px;
                            top: 120%;
                            right: 240px;
                        }

                        li:nth-child(5):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 78%;
                            right: 8%;
                        }

                        li:nth-child(6):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 350px;
                            height: 350px;
                            top: 95%;
                            left: 18%;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 900px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 800px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 30px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-around;
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-left: 0px;
                                width: 250px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 500px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: 0px !important;
                                margin-top: 0px;
                                height: 200px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-right: 10px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -40px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 150px;

                            img {
                                margin-left: 20px;
                                width: 250px;
                                height: 250px;
                                margin-top: 0px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px;
                                margin-right: 0px;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    margin-bottom: 20px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    width: 400px;
                                    line-height: 35px;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: -0px !important;
                                width: 250px;
                                height: 200px;
                                margin: auto 0;
                                margin-top: 70px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: 10px !important;
                                margin-left: 0px;
                                margin-top: 0px;
                                width: 250px;
                                height: 200px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -20.5px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 450px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 150px;

                            img {
                                margin-right: 0px !important;
                                margin-left: 0px;
                                margin-top: 0.5px;
                                width: 300px;
                                height: 250px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -20px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 100%;
                            height: 640px;
                            margin-top: 0px;
                            margin-bottom: 0 !important;

                            img {
                                margin-right: -0px !important;
                                margin-left: 40px;
                                margin-top: 79px;
                                width: 300px;
                                height: 900px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 500px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 450px;
                                    line-height: 35px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 850px;
                            height: 400px;
                            top: 80%;
                            left: 9%;
                        }

                        li:nth-child(2):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 400px;
                            height: 250px;
                            top: 109%;
                            right: 13%;
                        }

                        li:nth-child(3):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 95%;
                            left: 10%;
                        }

                        li:nth-child(4):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 250px;
                            top: 120%;
                            right: 240px;
                        }

                        li:nth-child(5):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 78%;
                            right: 8%;
                        }

                        li:nth-child(6):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 350px;
                            height: 350px;
                            top: 95%;
                            left: 18%;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 800px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 700px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 30px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-around;
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-left: 0px;
                                width: 250px;
                                height: 220px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: 0px !important;
                                margin-top: 0px;
                                height: 200px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-right: 10px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -40px;
                                    margin-bottom: 30px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 380px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 150px;

                            img {
                                margin-left: 20px;
                                width: 250px;
                                height: 250px;
                                margin-top: 0px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px;
                                margin-right: 0px;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    margin-bottom: 20px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    width: 400px;
                                    line-height: 35px;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: -0px !important;
                                width: 250px;
                                height: 200px;
                                margin: auto 0;
                                margin-top: 70px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-right: 10px !important;
                                margin-left: 0px;
                                margin-top: 0px;
                                width: 250px;
                                height: 200px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 20px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -20.5px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 150px;

                            img {
                                margin-right: 0px !important;
                                margin-left: 0px;
                                margin-top: 0.5px;
                                width: 300px;
                                height: 250px;
                                margin: auto 0;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -20px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 100%;
                            height: 640px;
                            margin-top: 0px;
                            margin-bottom: 0 !important;

                            img {
                                margin-right: -0px !important;
                                margin-left: 40px;
                                margin-top: 79px;
                                width: 300px;
                                height: 900px;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: -0px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 500px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 450px;
                                    line-height: 35px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 850px;
                            height: 400px;
                            top: 80%;
                            left: 9%;
                        }

                        li:nth-child(2):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 400px;
                            height: 250px;
                            top: 109%;
                            right: 13%;
                        }

                        li:nth-child(3):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 95%;
                            left: 10%;
                        }

                        li:nth-child(4):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 250px;
                            top: 120%;
                            right: 240px;
                        }

                        li:nth-child(5):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 78%;
                            right: 8%;
                        }

                        li:nth-child(6):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 350px;
                            height: 350px;
                            top: 95%;
                            left: 18%;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 700px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 600px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 30px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            flex-direction: column;
                            justify-content: center;
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-left: 0px;
                                width: 400px;
                                height: 300px;
                                margin: 0 auto;
                            }

                            div {
                                margin-left: 0px;
                                margin: 0 auto;
                                margin-top: 20px;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    text-align: center;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 200px;
                            flex-direction: column !important;
                            justify-content: center;

                            img {
                                height: 200px;
                                padding: 0;
                                margin: 0 auto !important;
                                margin: 0 auto;
                            }

                            div {
                                margin-right: 10px !important;
                                margin: 0 auto;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 380px;
                                    line-height: 35px;
                                    text-align: center;
                                    margin-left: 3px;
                                    margin: 0 auto;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 150px;

                            img {
                                margin-left: 20px;
                                width: 250px;
                                height: 250px;
                                margin-top: 0px;
                                margin: 0 auto;
                            }

                            div {
                                margin-left: 20px;
                                margin-right: 0px;
                                margin: 0 auto;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 20px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    width: 400px;
                                    line-height: 35px;
                                    text-align: center;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 200px;
                            flex-direction: column !important;

                            img {
                                margin-right: -0px !important;
                                width: 250px;
                                height: 200px;
                                margin-top: 70px;
                                margin: 0 auto !important;
                            }

                            div {
                                margin-left: 0px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 200px;
                            flex-direction: column !important;

                            img {
                                margin-right: 10px !important;
                                margin-left: 0px;
                                margin-top: 0px;
                                width: 250px;
                                height: 200px;
                                margin: 0 auto !important;
                            }

                            div {
                                margin-left: 20px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 28px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 500px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 150px;
                            flex-direction: column !important;

                            img {
                                margin-right: 0px !important;
                                margin-left: 0px;
                                margin-top: 0.5px;
                                width: 300px;
                                height: 250px;
                                margin: 0 auto !important;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                    text-align: center;
                                    margin: 0 auto;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 100%;
                            height: 840px;
                            margin-top: 0px;
                            margin-bottom: 0 !important;
                            position: relative;

                            img {
                                position: absolute;
                                margin-right: -0px !important;
                                margin-left: 40px;
                                margin-top: -179px;
                                width: 300px;
                                height: 900px;
                                margin: 0 auto !important;
                                left: 0;
                                right: 0;
                                top: 20px;
                                z-index: -5;
                            }

                            div {
                                margin-left: 0px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 600px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 500px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 450px;
                                    line-height: 35px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                    margin: 0 auto !important;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 850px;
                            height: 400px;
                            top: 80%;
                            left: 9%;
                        }

                        li:nth-child(2):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 400px;
                            height: 250px;
                            top: 109%;
                            right: 13%;
                        }

                        li:nth-child(3):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 95%;
                            left: 10%;
                        }

                        li:nth-child(4):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 250px;
                            top: 120%;
                            right: 240px;
                        }

                        li:nth-child(5):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 78%;
                            right: 8%;
                        }

                        li:nth-child(6):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 350px;
                            height: 350px;
                            top: 95%;
                            left: 18%;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 600px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 500px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 30px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            flex-direction: column;
                            justify-content: center;
                            position: relative;
                            margin-bottom: 200px;

                            img {
                                margin-left: 0px;
                                width: 400px;
                                height: 300px;
                                margin: 0 auto;
                            }

                            div {
                                margin-left: 0px;
                                margin: 0 auto;
                                margin-top: 20px;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    text-align: center;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 200px;
                            flex-direction: column !important;
                            justify-content: center;

                            img {
                                height: 200px;
                                padding: 0;
                                margin: 0 auto !important;
                                margin: 0 auto;
                            }

                            div {
                                margin-right: 10px !important;
                                margin: 0 auto;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 380px;
                                    line-height: 35px;
                                    text-align: center;
                                    margin-left: 3px;
                                    margin: 0 auto;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 150px;

                            img {
                                margin-left: 20px;
                                width: 250px;
                                height: 250px;
                                margin-top: 0px;
                                margin: 0 auto;
                            }

                            div {
                                margin-left: 20px;
                                margin-right: 0px;
                                margin: 0 auto;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 20px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    width: 400px;
                                    line-height: 35px;
                                    text-align: center;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 200px;
                            flex-direction: column !important;

                            img {
                                margin-right: -0px !important;
                                width: 250px;
                                height: 200px;
                                margin-top: 70px;
                                margin: 0 auto !important;
                            }

                            div {
                                margin-left: 0px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 200px;
                            flex-direction: column !important;

                            img {
                                margin-right: 10px !important;
                                margin-left: 0px;
                                margin-top: 0px;
                                width: 250px;
                                height: 200px;
                                margin: 0 auto !important;
                            }

                            div {
                                margin-left: 20px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 28px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 500px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 150px;
                            flex-direction: column !important;

                            img {
                                margin-right: 0px !important;
                                margin-left: 0px;
                                margin-top: 0.5px;
                                width: 300px;
                                height: 250px;
                                margin: 0 auto !important;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                    text-align: center;
                                    margin: 0 auto;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 100%;
                            height: 840px;
                            margin-top: 0px;
                            margin-bottom: 0 !important;
                            position: relative;

                            img {
                                position: absolute;
                                margin-right: -0px !important;
                                margin-left: 40px;
                                margin-top: -179px;
                                width: 300px;
                                height: 900px;
                                margin: 0 auto !important;
                                left: 0;
                                right: 0;
                                top: 20px;
                                z-index: -5;
                            }

                            div {
                                margin-left: 0px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 600px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 500px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 450px;
                                    line-height: 35px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                    margin: 0 auto !important;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 850px;
                            height: 400px;
                            top: 80%;
                            left: 9%;
                        }

                        li:nth-child(2):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 400px;
                            height: 250px;
                            top: 109%;
                            right: 13%;
                        }

                        li:nth-child(3):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 95%;
                            left: 10%;
                        }

                        li:nth-child(4):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 250px;
                            top: 120%;
                            right: 240px;
                        }

                        li:nth-child(5):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 78%;
                            right: 8%;
                        }

                        li:nth-child(6):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 350px;
                            height: 350px;
                            top: 95%;
                            left: 18%;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 500px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 400px;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 30px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            flex-direction: column;
                            justify-content: center;
                            position: relative;
                            margin-bottom: 100px;

                            img {
                                margin-left: 0px;
                                width: 90%;
                                height: auto;
                                margin: 0 auto;
                            }

                            div {
                                margin-left: 0px;
                                margin: 0 auto;
                                margin-top: 20px;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    text-align: center;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 100px;
                            flex-direction: column !important;
                            justify-content: center;

                            img {
                                height: auto;
                                width: 90%;
                                padding: 0;
                                margin: 0 auto !important;
                                margin: 0 auto;
                            }

                            div {
                                margin-right: 10px !important;
                                margin: 0 auto;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 380px;
                                    line-height: 35px;
                                    text-align: center;
                                    margin-left: 3px;
                                    margin: 0 auto;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 100px;

                            img {
                                margin-left: 20px;
                                width: 90%;
                                height: auto;
                                margin-top: 0px;
                                margin: 0 auto;
                            }

                            div {
                                margin-left: 20px;
                                margin-right: 0px;
                                margin: 0 auto;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 20px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    width: 400px;
                                    line-height: 35px;
                                    margin: 0 auto;
                                    text-align: center;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 150px;
                            flex-direction: column !important;

                            img {
                                margin-right: -0px !important;
                                width: 250px;
                                height: 200px;
                                margin-top: 70px;
                                margin: 0 auto !important;
                            }

                            div {
                                margin-left: 0px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    line-height: 35px;
                                    margin-left: 3px;
                                    max-width: 400px;

                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 200px;
                            flex-direction: column !important;

                            img {
                                margin-right: 10px !important;
                                margin-left: 0px;
                                margin-top: 0px;
                                width: 90%;
                                height: auto;
                                margin: 0 auto !important;
                            }

                            div {
                                margin-left: 20px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 28px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 150px;
                            flex-direction: column !important;

                            img {
                                margin-right: 0px !important;
                                margin-left: 0px;
                                margin-top: 0.5px;
                                width: 90%;
                                height: auto;
                                margin: 0 auto !important;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 400px;
                                    line-height: 35px;
                                    margin-left: 3px;
                                    text-align: center;
                                    margin: 0 auto;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 100%;
                            height: 1300px;
                            margin-top: 0px;
                            margin-bottom: 0 !important;
                            position: relative;

                            img {
                                position: absolute;
                                width: 90%;
                                height: auto;
                                margin: 0 auto !important;

                                top: 20px;
                                z-index: -5;
                                left: 20%;

                            }

                            div {
                                margin-left: 0px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 400px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 400px;
                                }

                                p {
                                    font-size: 16px;
                                    color: #8a8a8a;
                                    max-width: 350px;
                                    line-height: 35px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                    margin: 0 auto !important;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 850px;
                            height: 400px;
                            top: 80%;
                            left: 9%;
                        }

                        li:nth-child(2):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 400px;
                            height: 250px;
                            top: 109%;
                            right: 13%;
                        }

                        li:nth-child(3):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 95%;
                            left: 10%;
                        }

                        li:nth-child(4):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 250px;
                            top: 120%;
                            right: 240px;
                        }

                        li:nth-child(5):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 78%;
                            right: 8%;
                        }

                        li:nth-child(6):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 350px;
                            height: 350px;
                            top: 95%;
                            left: 18%;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 410px) {
        .WorkLineSection {
            .WorkLineWrapper {
                width: 90%;
                margin: 0 auto;

                .WorkLineBody {
                    h2 {
                        font-size: 30px;
                        color: #217a73;
                        text-align: center;
                        font-weight: 600;
                        margin-top: 100px;
                    }

                    ul {
                        margin-top: 73px;

                        li {
                            display: flex;
                            flex-direction: row;
                            flex-direction: column;
                            justify-content: center;
                            position: relative;
                            margin-bottom: 100px;

                            img {
                                margin-left: 0px;
                                width: 90%;
                                height: auto;
                                margin: 0 auto;
                            }

                            div {
                                margin-left: 0px;
                                margin: 0 auto;
                                margin-top: 20px;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    text-align: center;
                                    color: #8a8a8a;
                                    width: 90%;
                                    line-height: 40px;
                                }
                            }
                        }

                        li:nth-child(2) {
                            position: relative;
                            margin-bottom: 100px;
                            flex-direction: column !important;
                            justify-content: center;

                            img {
                                height: auto;
                                width: 90%;
                                padding: 0;
                                margin: 0 auto !important;
                                margin: 0 auto;
                            }

                            div {
                                margin-right: 10px !important;
                                margin: 0 auto;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 30px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    max-width: 90%;
                                    line-height: 35px;
                                    text-align: center;
                                    margin-left: 3px;
                                    margin: 0 auto;
                                }
                            }
                        }

                        li:nth-child(3) {
                            display: flex;
                            position: relative;
                            margin-bottom: 100px;

                            img {
                                margin-left: 20px;
                                width: 90%;
                                height: auto;
                                margin-top: 0px;
                                margin: 0 auto;
                            }

                            div {
                                margin-left: 20px;
                                margin-right: 0px;
                                margin: 0 auto;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 20px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    width: 90%;

                                    line-height: 35px;
                                    margin: 0 auto;
                                    text-align: center;
                                }
                            }
                        }

                        li:nth-child(4) {
                            position: relative;
                            margin-bottom: 150px;
                            flex-direction: column !important;

                            img {
                                margin-right: -0px !important;
                                width: 250px;
                                height: 200px;
                                margin-top: 70px;
                                margin: 0 auto !important;
                            }

                            div {
                                margin-left: 0px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 65px;
                                    margin-bottom: 28px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    line-height: 35px;
                                    margin-left: 3px;
                                    width: 90%;
                                }
                            }
                        }

                        li:nth-child(5) {
                            position: relative;
                            margin-bottom: 200px;
                            flex-direction: column !important;

                            img {
                                margin-right: 10px !important;
                                margin-left: 0px;
                                margin-top: 0px;
                                width: 90%;
                                height: auto;
                                margin: 0 auto !important;
                            }

                            div {
                                margin-left: 20px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 28px;
                                    text-align: center;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    width: 90%;
                                    line-height: 35px;
                                    margin-left: 3px;
                                }
                            }
                        }

                        li:nth-child(6) {
                            position: relative;
                            margin-bottom: 150px;
                            flex-direction: column !important;

                            img {
                                margin-right: 0px !important;
                                margin-left: 0px;
                                margin-top: 0.5px;
                                width: 90%;
                                height: auto;
                                margin: 0 auto !important;
                            }

                            div {
                                margin: auto 0;
                                margin-left: 0px !important;

                                h4 {
                                    font-size: 22px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 20px;
                                    margin-bottom: 28px;
                                }

                                p {
                                    font-size: 18px;
                                    color: #8a8a8a;
                                    width: 90%;
                                    line-height: 35px;
                                    margin-left: 3px;
                                    text-align: center;
                                    margin: 0 auto;
                                }
                            }
                        }

                        li:nth-child(7) {
                            position: relative;
                            overflow-y: hidden;
                            overflow-x: hidden;
                            width: 100%;
                            height: 1400px;
                            margin-top: 0px;
                            margin-bottom: 0 !important;
                            position: relative;

                            img {
                                position: absolute;
                                width: 90%;
                                height: auto;
                                margin: 0 auto !important;
                                top: 20px;
                                z-index: -5;
                                left: 20%;
                            }

                            div {
                                margin-left: 0px !important;
                                margin: 0 auto !important;

                                h4 {
                                    font-size: 20px;
                                    color: #217a73;
                                    margin-top: 0px;
                                    font-weight: 600;
                                    margin-bottom: 0px;
                                    margin-top: 400px;
                                    line-height: 40px;
                                    margin-bottom: 24px;
                                    margin-left: -0px;
                                    width: 90%;

                                }

                                p {
                                    font-size: 14px;
                                    color: #8a8a8a;
                                    width: 80%;
                                    line-height: 35px;
                                    margin-left: 0px;
                                    margin-right: 5px;
                                    margin-bottom: 40px;
                                    margin: 0 auto !important;
                                    padding: 0;
                                }
                            }
                        }

                        li:nth-child(2n) {
                            flex-direction: row-reverse;
                        }

                        li:nth-child(1):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1582.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 850px;
                            height: 400px;
                            top: 80%;
                            left: 9%;
                        }

                        li:nth-child(2):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/Group 1583.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 400px;
                            height: 250px;
                            top: 109%;
                            right: 13%;
                        }

                        li:nth-child(3):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1586.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 95%;
                            left: 10%;
                        }

                        li:nth-child(4):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1587.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 500px;
                            height: 250px;
                            top: 120%;
                            right: 240px;
                        }

                        li:nth-child(5):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1589.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 800px;
                            height: 500px;
                            top: 78%;
                            right: 8%;
                        }

                        li:nth-child(6):after {
                            display: none;
                            content: "";
                            position: absolute;
                            background-image: url("../assets/images/images_work_line/Group 1588.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            width: 350px;
                            height: 350px;
                            top: 95%;
                            left: 18%;
                        }
                    }
                }
            }
        }
    }
    
</style>